
<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import SettingsQrCampaign from "@/components/SettingsQrCampaign";

/**
 * Reporting component
 */
export default {
  page: {
    title: "SettingsMenu",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {Layout, SettingsQrCampaign},

};
</script>

<template>
  <Layout>
    <div class="px-3">
      <SettingsQrCampaign></SettingsQrCampaign>
    </div>

  </Layout>
</template>
